module.exports = __webpack_public_path__ + "web/img/grade1.b330f509.png";